/* eslint-disable no-underscore-dangle */

const appendWistiaScriptIfMissing = () => {
  if (!document.getElementById('wistia_script')) {
    const wistiaScript = document.createElement('script');
    wistiaScript.id = 'wistia_script';
    wistiaScript.type = 'text/javascript';
    wistiaScript.src = '//fast.wistia.com/assets/external/E-v1.js';
    wistiaScript.async = true;
    document.body.appendChild(wistiaScript);
  }
};

const addVideoToQueue = videoDetails => {
  // Initialise Wistia video queue to empty array if undefined
  window._wq = window._wq || [];

  // Push new video to queue
  window._wq.push(videoDetails);
};

export { appendWistiaScriptIfMissing, addVideoToQueue };
